import { FC, memo } from 'react'

import { Text, Button } from '@cash-me/react-components'
import NextImage from "next/image"

import { Grid, Col } from 'components/grid'
import useWindowSize from 'hooks/useWindowSize'

import { DescriptionProps } from './description.model'
import * as S from './styles'

const Description: FC<DescriptionProps> = memo(({ onClick }) => {
  const { isTablet } = useWindowSize()

  return (
    <S.Section>
      <Grid col={{ phone: 1, tablet: 12, desktop: 12 }}>
        <Col col={{ tablet: 6, desktop: 5 }}>
          <S.ImageMobWrapper>
            <S.ImageMob>
              <NextImage
                src={`${process.env.NEXT_PUBLIC_SITE_IMAGES_PREFIX}/images/site/defaulter/how-works-mobile.png`}
                alt="Mulher analisando papéis"
                width="324"
                height="173"
                sizes="100vw"
                style={{
                  width: "100%",
                  height: "auto"
                }} />
            </S.ImageMob>
          </S.ImageMobWrapper>

          <S.ImageDesk>
            <NextImage
              src={`${process.env.NEXT_PUBLIC_SITE_IMAGES_PREFIX}/images/site/defaulter/how-works-desktop.webp`}
              alt="Mulher analisando papéis"
              width="632"
              height="881"
              sizes="100vw"
              style={{
                width: "100%",
                height: "auto"
              }} />
          </S.ImageDesk>
        </Col>
        <Col start={{ desktop: 7 }} col={{ tablet: 6, desktop: 5 }}>
          <S.Infos>
            <Text className="subtitle" size="caption" weight="medium" uppercase>
              Empréstimo para pagamento de dívidas
            </Text>

            <Text as="h2" size="heading2" weight="medium">
              <Text as="span" size="heading2" weight="medium" color="var(--colors-pink-text-default)">
                Como funciona{' '}
              </Text>
              a Portabilidade de Dívidas com garantia de imóvel?
            </Text>

            <Text className="description" color="var(--colors-neutral-text-weak)">
              Conhecido também como home equity ou refinanciamento de imóvel, o Empréstimo com Garantia de Imóvel é uma
              linha de crédito que, ao utilizar o bem como aval, oferece taxas de juros muito mais baixas se comparadas
              às outras modalidades de crédito.
            </Text>
            <Text className="description" color="var(--colors-neutral-text-weak)">
              Além disso, você pode continuar usufruindo do imóvel normalmente. Esse tipo de financiamento é uma das
              opções mais baratas e vantajosas do mercado.
            </Text>

            <Button
              size="lg"
              onClick={onClick}
              {...(isTablet ? { variants: 'default', iconName: 'arrowRight' } : { variants: 'text-only' })}
            >
              Simular agora
            </Button>
          </S.Infos>
        </Col>
      </Grid>
    </S.Section>
  );
})

Description.displayName = 'Description'

export default Description
